
import {format, formatISO} from "date-fns";
import Papaparse from "papaparse";

import LocalImageDbService from "../services/LocalImageDbService";
import LocalDocumentDbService from "../services/LocalDocumentDbService";
import BlobStorageService from "../services/BlobStorageService";
import ConfigService from "../services/ConfigService.js";
import CoreService from "../services/CoreService";

import ServiceResponse from "../models/ServiceResponse";




export default class FileManager
{
    constructor()
    {

        this.configService = new ConfigService();
        this.localImageDbService = new LocalImageDbService();
        this.localDocumentDbService = new LocalDocumentDbService();
        this.blobStorageService = new BlobStorageService();
        this.coreService = new CoreService();
    }



    async uploadUserImages(observation, userSession)
    {
        if (!observation.data.hasImages) return ServiceResponse.toServiceResponse("No Associated Images", false);
        var msgs = [];
        for(const img of observation.data.Raw.userimages)
        {
          // fetch the image from local storage
          var hasLocalImgResponse = await this.localImageDbService.hasImage(userSession.gcid, img.id);
          if (hasLocalImgResponse.data)
          {
            var localImgResponse = await this.localImageDbService.fetchImage(userSession.gcid, img.id);
            var localImgUri = localImgResponse.data;
            var sasUriResponse = await this.coreService.fetchUserImgSasUri(img.id, img.ext, userSession.gcid, userSession.token);
            var sasUri = sasUriResponse.dataResult;
            var uploadResult = await this.blobStorageService.uploadUserImage(localImgUri, sasUri);
            if (uploadResult.hasError) return uploadResult;
            msgs.push(uploadResult.messages);
            // fetch thumbnail from local storage
            if (img.thumbnailId)
            {
              var localThumbImgResponse = await this.localImageDbService.fetchImage(userSession.gcid, img.thumbnailId);
              var localThumbImgUri = localThumbImgResponse.data;
              var thumbSasUriResponse = await this.coreService.fetchUserImgSasUri(img.thumbnailId, img.ext, userSession.gcid, userSession.token);
              var thumbSasUri = thumbSasUriResponse.dataResult;
              var thumbUploadResult = await this.blobStorageService.uploadUserImage(localThumbImgUri, thumbSasUri);
              if (thumbUploadResult.hasError) return thumbUploadResult;
              msgs.push(thumbUploadResult.messages);
            }
          }
        }
        return ServiceResponse.toServiceResponse(msgs, false);
    }
  
    async deleteUserImages(observation)
    {
      var msgs = [];
      var hasError = false;
      if (!observation.data.hasImages) return ServiceResponse.toServiceResponse("No Associated Images", false);
      var msgs = [];
      for(const img of observation.data.Raw.userimages)
      {
        var delResult = await this.localImageDbService.deleteImage(img.id);
        if (!hasError) hasError = delResult.hasError;
        msgs.push(delResult.messages);
        if (img.thumbnailId)
        {
          var thumbDelResult = await this.localImageDbService.deleteImage(img.thumbnailId);
          if (!hasError) hasError = thumbDelResult.hasError;
          msgs.push(thumbDelResult.messages);
        }
      }
      return ServiceResponse.toServiceResponse(msgs, hasError);
    }
  
  
    async uploadUserDocuments(observation, userSession)
    {
      if (!observation.data.hasDocs) return ServiceResponse.toServiceResponse("No Associated Documents", false);
      var msgs = [];
      for(const doc of observation.data.Raw.userdocs)
      {
        // fetch the doc from local storage
        var localDocExistsResponse = await this.localDocumentDbService.hasDocument(userSession.gcid, doc.id);
        var hasLocalDoc = localDocExistsResponse.data;
        if (hasLocalDoc)
        {
          var localDocResponse = await this.localDocumentDbService.fetchDocument(userSession.gcid, doc.id);
          var localDocUri = localDocResponse.data;
          var sasUriResponse = await this.coreService.fetchUserDocSasUri(doc.id, doc.ext, userSession.gcid, userSession.token);
          var sasUri = sasUriResponse.dataResult;
          var uploadResult = await this.blobStorageService.uploadBlobFile(localDocUri, sasUri);
          if (uploadResult.hasError) return uploadResult;
          msgs.push(uploadResult.messages);
          // fetch thumbnail from local storage
          if (doc.thumbnailId)
          {
            var localImgExistsResponse = await this.localImageDbService.hasImage(userSession.gcid, doc.thumbnailId);
            var hasLocalImg = localImgExistsResponse.data;
            if (hasLocalImg)
            {
              var localThumbImgResponse = await this.localImageDbService.fetchImage(userSession.gcid, doc.thumbnailId);
              var localThumbImgUri = localThumbImgResponse.data;
              var thumbSasUriResponse = await this.coreService.fetchUserImgSasUri(doc.thumbnailId, 'png', userSession.gcid, userSession.token);
              var thumbSasUri = thumbSasUriResponse.dataResult;
              var thumbUploadResult = await this.blobStorageService.uploadUserImage(localThumbImgUri, thumbSasUri);
              if (thumbUploadResult.hasError) return thumbUploadResult;
              msgs.push(thumbUploadResult.messages);
            }
          }
        }
      }
      return ServiceResponse.toServiceResponse(msgs, false);
    }
  
    async deleteUserDocuments(observation)
    {
      if (!observation.data.hasDocs) return ServiceResponse.toServiceResponse("No Associated Documents", false);
      var msgs = [];
      var hasError = false;
      for(const doc of observation.data.Raw.userdocs)
      {
        var delResult = await this.localDocumentDbService.deleteDocument(doc.id);
        if (!hasError) hasError = delResult.hasError;
        msgs.push(delResult.messages);
        if (doc.thumbnailId)
        {
          var thumbDelResult = await this.localImageDbService.deleteImage(doc.thumbnailId);
          if (!hasError) hasError = thumbDelResult.hasError;
          msgs.push(thumbDelResult.messages);
        }
      }
      return ServiceResponse.toServiceResponse(msgs, hasError);
    }


    static insertUserImageCards(userImages, schema, disallowRemove, insertSchemaCardIntoSchema)
    {
      if (!userImages) return schema;
      userImages.forEach((imgObj) => {
        // insert a card for each image
        insertSchemaCardIntoSchema(schema, "notes", "Images",
        {
          "id": imgObj.id, "thumbnailId": imgObj.thumbnailId, "disallowToggle": true, "disallowRemove": disallowRemove,
          "title": ((imgObj.descript) && (imgObj.descript !== "")) ? imgObj.descript: "user image" , "fieldType": "userimage", "arrayValue": true,  "parentId": "userimages", "descript": imgObj.descript,
          "tags": imgObj.tags, "dataUri": imgObj.dataUri, 
          "ext": imgObj.ext,
          "thumbnailExt": imgObj.thumbnailExt, "thumbnailUri": imgObj.thumbnailUri, "colspan": 1
        });
      });
      return schema;
    }

    static insertUserDocCards(userDocs, schema, disallowRemove, insertSchemaCardIntoSchema)
    {
      if (!userDocs) return schema;

      userDocs.forEach((fl) => {
      //insert a card for each doc
      insertSchemaCardIntoSchema(schema, "notes", "Documents",
        {
            "id": fl.id, "title": "user file", "fieldType": "userdoc", "disallowToggle": true, "disallowRemove": disallowRemove, "arrayValue": true, "parentId": "userdocs", "multiValueType": "array", "descript": fl.descript ?? "",
            "tags": fl.tags ?? [], "dataUri": fl.dataUri, 
            thumbnailId: fl.thumbnailId, thumbnailExt: fl.thumbnailExt, thumbnailUri: fl.thumbnailUri
        });
      });
    }





}


